import React, { useEffect } from "react";

function ChatbotEmbed() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://worker.aivacompany.com/webhook/0eec179d-8f18-499d-ac45-88b02adaa208/chat";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
}

export default ChatbotEmbed;
